// Detecta si el usuario está en modo administrador.
// Se activa entrando a la URL: ?admin=<TOKEN> (guarda flag en localStorage).
// El token real lo valida el backend en cada petición vía X-Admin-Token.
// Se desactiva con: ?admin=off  (o borrando localStorage)
export const isAdminMode = () => {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    const adminParam = params.get('admin');
    if (adminParam === 'off') {
      localStorage.removeItem('jrf-admin');
      return false;
    }
    if (adminParam && adminParam.length > 0) {
      localStorage.setItem('jrf-admin', 'true');
      return true;
    }
    return localStorage.getItem('jrf-admin') === 'true';
  } catch (e) {
    return false;
  }
};

export const setAdminMode = (enabled) => {
  if (typeof window === 'undefined') return;
  try {
    if (enabled) localStorage.setItem('jrf-admin', 'true');
    else localStorage.removeItem('jrf-admin');
  } catch (e) {}
};
